import { fileUrl } from "../../../../../utils";

type IpropsOemIsvHeader = {
  profil: string;
  companyName: string;
  roleDiscussion: string;
  companyId: string;
};
export default function OemToIsvHeaderMessage(props: IpropsOemIsvHeader) {
  const companyUrl = "/company/company-unlocked/" + props.companyId;
  return (
    <>
      <div className="d-flex mr-5">
        <div className="photo-title">
          {props.profil && <img src={fileUrl(props.profil)} alt="profil" />}
        </div>
        <div className="info-title">
          <div className="company-title">
            <a href="javascript:;" className="disable-click-name">
              {props?.companyName || "-"}
            </a>
          </div>
          <div className="company-type">{props?.roleDiscussion || "-"}</div>
        </div>
      </div>
    </>
  );
}
